<template>
  <div class="card-wrapper">
    <b-card v-for="option in options" :key="option.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ option.key }}
          </p>
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ option.value }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i @click="showInfoModal(option.id)" class="glyph-icon simple-icon-pencil datalist-icon mr-md-3 mr-2"></i>

          <i @click="handleDelete(option.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editOptionModal" ref="editOptionModal" size="lg" :title="'Edit Option'">
      <b-row v-if="!isLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('pages.options.key')">
                <b-form-input type="text" v-model="$v.editForm.key.$model" :state="!$v.editForm.key.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.key.required">
                  {{ $t('formErrors.enterKey') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.options.value')">
                <b-form-input type="text" v-model="$v.editForm.value.$model" :state="!$v.editForm.value.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.value.required">
                  {{ $t('formErrors.enterValue') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-2">
                {{ $t('buttons.save') }}
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editOptionModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
const { required } = require('vuelidate/lib/validators')

export default {
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      editForm: {
        key: '',
        value: ''
      },
      currentOption: null
    }
  },
  validations: {
    editForm: {
      key: { required },
      value: { required }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editOptionModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('options/deleteOption', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoModal(id) {
      this.$bvModal.show('editOptionModal')
      this.$store.dispatch('options/fetchOption', { id, vm: this })
      this.currentOption = id
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('options/updateOption', {
          payload: this.editForm,
          id: this.currentOption,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.key = ''
      this.editForm.value = ''
      this.currentOption = null
    },
    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
